module.exports = __webpack_public_path__ + "static/media/Eye.cb94f9a2.svg";